    import React, { useEffect, useState } from "react";
    import { DataTable } from "primereact/datatable";
    import { Column } from "primereact/column";
    import { formateDateTime } from "../../../../services/date_service";
    import { InputText } from "primereact/inputtext";
    import * as Yup from "yup";
    import classNames from "classnames";
    import { Formik, useFormik } from "formik";
    import { Dropdown } from "primereact/dropdown";
    import { Button } from "primereact/button";
    import { ColumnGroup } from "primereact/columngroup";
    import { Row } from "primereact/row";
    import moment from "moment";
    import * as XLSX from "xlsx";
    import appUrl from "../../../config/appUrl";
    import { Dialog } from "primereact/dialog";
    import { FilterMatchMode } from "primereact/api";
    import { useLocation } from "react-router-dom";
    import { Checkbox } from "primereact/checkbox";
    import { InputTextarea } from "primereact/inputtextarea";
    import { toast } from "react-toastify";

    const BarrierLogReport = ({ onHide, getBoothList, addEditBooth, boothId }) => {
      const [dashList, setDashList] = useState([]);
      const [dashStat, setDashStat] = useState([]);
      const [showFilters, setShowFilters] = useState(false);
      const [appliedFilters, setAppliedFilters] = useState(0);
      const [totalFee, setTotalFee] = useState("");
      const [siteList, setSiteList] = useState([]);
      const [boothList, setBoothList] = useState("");
      const [exportLoading, setExportLoading] = useState(false);
      const [booothId, setBooothId] = useState("");
      const [siteId, setSiteId] = useState("");
      const [loading, setLoading] = useState(false);
      const [selectedUser, setSelectedUser] = useState("");
      const [siteValue, setSitevalue] = useState(null);
      const [filteredUserList, setFilteredUserList] = useState([]);
      const [userList, setUserList] = useState([]);
      const [globalFilterValue, setGlobalFilterValue] = useState("");
      const [initialized, setInitialized] = useState(false);
      const [currentPage, setCurrentPage] = useState(1);
      const [currentPageSize, setCurrentPageSize] = useState(10);
      const [vehicleTypeList, setVehicleTypeList] = useState([]);
      const [totalRecords, setTotalRecords] = useState(0);
      const [selectedVehicleType, setSelectedVehicleType] = useState(null);
      const [dateWiseDataOnly, setDateWiseDataOnly] = useState(false);
      const [isCheckInMissing, setIsCheckInMissing] = useState(true);
      const location = useLocation();
      const queryParams = new URLSearchParams(location.search);

      // ── Resolve dialog state ──────────────────────────────────────────────────
      const [resolveDialog, setResolveDialog] = useState(false);
      const [resolveRow, setResolveRow] = useState(null);
      const [ticketNo, setTicketNo] = useState("");
      const [description, setDescription] = useState("");
      const [ticketImageB64, setTicketImageB64] = useState(null);
      const [ticketImagePreview, setTicketImagePreview] = useState(null);
      const [resolveLoading, setResolveLoading] = useState(false);
      // ──────────────────────────────────────────────────────────────────────────

      const date = new Date();
      let currentDate = moment(date).format("YYYY-MM-DD");

      const [fromDate, setFromDate] = useState(currentDate);
      const [toDate, setToDate] = useState(currentDate);
      const [selectedImage, setSelectedImage] = useState(null);
      const [imageDialog, setImageDialog] = useState(false);

      const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      });

      const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setGlobalFilterValue(value);
        getDashData(1, currentPageSize, value);
        setCurrentPage(1);
      };

      const validationSchema = Yup.object().shape({});

      const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
          boothId: "",
          fromDate: "",
          toDate: "",
          site: "",
        },
      });

      const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);
      const getFormErrorMessage = (name) => {
        return (
          isFormFieldValid(name) && (
            <small className="p-error">{formik.errors[name]}</small>
          )
        );
      };

      useEffect(() => {
        const count = [
          formik.values.site,
          formik.values.boothId,
          fromDate,
          toDate,
        ].filter((val) => val).length;
        setAppliedFilters(count);
      }, [formik.values.site, formik.values.boothId, fromDate, toDate]);

      useEffect(() => {
        if (initialized && fromDate && toDate) {
          getDashData(1, currentPageSize);
        }
      }, [fromDate, toDate, siteId, initialized]);

      useEffect(() => {
        const fromDateParam = queryParams.get("fromDate");
        const toDateParam = queryParams.get("toDate");
        const siteParam = queryParams.get("site");

        if (fromDateParam && toDateParam) {
          setFromDate(fromDateParam);
          setToDate(toDateParam);
          if (siteParam) {
            formik.setFieldValue("site", siteParam);
            setSiteId(siteParam);
          }
          getDashData(1, currentPageSize, globalFilterValue);
        }
      }, []);

      useEffect(() => {
        const siteParam = queryParams.get("site");
        if (siteParam) {
          formik.setFieldValue("site", siteParam);
          setSiteId(siteParam);
          setSitevalue(siteList?.find((s) => s._id === siteParam) || null);
        }
      }, [siteList]);

    const getDashData = async (page = 1, pageSize = 10, Search = "") => {
    try {
      setLoading(true);
      setDashList([]);

      const requestBody = {
        fromDate: fromDate || null,
        toDate: toDate || null,
        site: siteId || null,
        booth: formik.values.boothId || null,
        excelExport: false,
        pageNumber: page,
        pageSize: pageSize,
        isCheckInMissing: isCheckInMissing,
      Search: Search || null,
      };

      const response = await fetch(
        `${appUrl.BASE_URL}BarrierLog/manualBarrierOpenLogs`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const result = await response.json();
      const allData = result?.data || [];   // 👈 اب اسی کو مانو کہ یہ صحیح (search کے ساتھ) filtered ہے

      const myData = allData.map((item, index) => ({
        _id: `${page}-${index}`,
        barrierLogId: item?.id || null,
        createdBy: item?.createdBy,
        createdAt: item?.createdAt,
        cameraSetPlateNo: item?.cameraSetPlateNo,
        plateImagePath: item?.plateImagePath,
        siteName: item?.siteName,
        booth: item?.booth,
        isCheckInMissing: item?.isCheckInMissing,
         parkingId: item?.parkingId ?? null,
  description: item?.description ?? null,          
  mappedAt: item?.mappedAt ?? null,                 
  mappedByUser: item?.mappedByUser ?? null,         
  ticketImagePath: item?.ticketImagePath ?? null
      }));

      setDashList(myData);
      setTotalRecords(result?.recordsTotal || 0);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setDashList([]);
      setTotalRecords(0);
      setLoading(false);
    }
  };

      useEffect(() => {
        getDashData(1, currentPageSize);
        setCurrentPage(1);
      }, []);

      const openImage = (url) => {
        setSelectedImage(url);
        setImageDialog(true);
      };

      // ── Resolve handlers ──────────────────────────────────────────────────────
      const openResolveDialog = (rowData) => {
        setResolveRow(rowData);
        setTicketNo("");
        setDescription("");
        setTicketImageB64(null);
        setTicketImagePreview(null);
        setResolveDialog(true);
      };

      const handleResolve = async () => {
        if (!ticketNo.trim()) {
          toast.warn("Please enter the Ticket Number.");
          return;
        }

        const storedLoginRes = JSON.parse(localStorage.getItem("user"));
        const userId = storedLoginRes?._id || storedLoginRes?.id || "";

        const payload = {
          barrierLogId: resolveRow?.barrierLogId,
          ticketNo: ticketNo.trim(),
          userId: userId,
          description: description || null,
          ticketImageB64: ticketImageB64 || null,
        };

        setResolveLoading(true);
        try {
          const response = await fetch(
            `${appUrl.BASE_URL}BarrierLog/mapBarrierlogWithCheckIn` ,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            }
          );

          const result = await response.json();

          if (response.ok && result?.status === true) {
            toast.success(result?.msg || "Record resolved successfully.");
            setResolveDialog(false);

            // Update row in-place instantly
            setDashList((prev) =>
              prev.map((item) =>
                item.barrierLogId === resolveRow?.barrierLogId
                  ? { ...item, isCheckInMissing: "No" }
                  : item
              )
            );

            getDashData(currentPage, currentPageSize, globalFilterValue);
          } else {
            toast.error(result?.message || result?.msg || "Failed to resolve.");
          }
        } catch (error) {
          console.error(error);
          toast.error("An error occurred. Please try again.");
        } finally {
          setResolveLoading(false);
        }
      };
      // ──────────────────────────────────────────────────────────────────────────

      const getBoothId = async () => {
        try {
          let apiUrl = `${appUrl.BASE_URL}booth/getBySite`;
          if (siteId) {
            apiUrl += `?siteId=${siteId}`;
          }
          const response = await fetch(apiUrl);
          const data = await response.json();
          setBoothList(data?.data);
        } catch (error) {
          console.error(error);
        }
      };

      const getSiteList = async () => {
        try {
          const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
          const data = await response.json();
          setSiteList(data?.data);
        } catch (error) {
          console.error(error);
        }
      };

      useEffect(() => {
        if (formik.values.site !== null && formik.values.site !== "") {
          getBoothId();
        }
        getSiteList();
      }, [formik.values.site]);

      const exportExcel = async () => {
        setExportLoading(true);
        try {
          const requestBody = {
            fromDate: fromDate || null,
            toDate: toDate || null,
            site: siteId || null,
            booth: formik.values.boothId || null,
            excelExport: true,
            isCheckInMissing: isCheckInMissing,
          };

          const response = await fetch(
            `${appUrl.BASE_URL}BarrierLog/manualBarrierOpenLogs`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(requestBody),
            }
          );

          if (!response.ok) throw new Error(`HTTP Error ${response.status}`);

          const result = await response.json();
          const exportDataRaw = result?.data || [];

          const exportData = exportDataRaw.map((item) => ({
            "Site Name": item.siteName || "",
            Booth: item.booth || "",
            "Plate No": item.cameraSetPlateNo || "",
            "Created At": item.createdAt
              ? moment.utc(item.createdAt).format("hh:mm:ss A YYYY-MM-DD")
              : "",
            "Created By": item.createdBy || "",
            "Check-In Missing": item.isCheckInMissing ? "Yes" : "No",
            "Mapped At": item.mappedAt                                    // 👈 add کیا
    ? moment.utc(item.mappedAt).format("hh:mm:ss A YYYY-MM-DD")
    : "",
  "Mapped By": item.mappedByUser || "",                         // 👈 add کیا
  "Description": item.description || "",                       // 👈 add کیا
  "Plate Image": getImageUrl(item.plateImagePath) || "",
  "Ticket Image": getImageUrl(item.ticketImagePath) || "", 
          }));

          const worksheet = XLSX.utils.json_to_sheet(exportData);
          worksheet["!cols"] = [
            { wch: 25 },
            { wch: 20 },
            { wch: 20 },
            { wch: 30 },
            { wch: 25 },
            { wch: 20 },
          ];
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "BarrierLogReport");
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
          saveAsExcelFile(excelBuffer, "BarrierLogReport");
        } catch (error) {
          console.error("Export failed:", error);
        } finally {
          setExportLoading(false);
        }
      };

      const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
          if (module && module.default) {
            const EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const EXCEL_EXTENSION = ".xlsx";
            const data = new Blob([buffer], { type: EXCEL_TYPE });
            module.default.saveAs(
              data,
              fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
            );
          }
        });
      };

      const storedLoginRes = JSON.parse(localStorage.getItem("user"));
      const userTypeIs = storedLoginRes?.role;
      const userSite = storedLoginRes?.site?._id;
      const isSiteFixed = userTypeIs !== "admin" && !!userSite;

      useEffect(() => {
        if (userTypeIs !== "admin" && userSite) {
          formik.setFieldValue("site", userSite);
          setSitevalue(userSite);
          setSiteId(userSite);
        } else {
          formik.setFieldValue("site", "");
          setSitevalue(null);
          setSiteId("");
        }
        setInitialized(true);
      }, []);

      useEffect(() => {
        const foundSite = siteList?.find((item) => item?._id === userSite);
        setSitevalue(foundSite);
      }, [userSite, siteList]);

      const handleDateChange = (e) => {
        setFromDate(e.target.value);
        setInitialized(true);
      };

      const getVehicleTypeList = async () => {
        try {
          const response = await fetch(`${appUrl.BASE_URL}category`);
          const data = await response.json();
          setVehicleTypeList(data);
        } catch (error) {
          console.error(error);
        }
      };

      useEffect(() => {
        if (fromDate && toDate && (siteId || siteId === "")) {
          getDashData(1, currentPageSize);
        }
      }, [fromDate, toDate, siteId, isCheckInMissing]);

      useEffect(() => {
        getVehicleTypeList();
      }, []);

      const getImageUrl = (fullPath) => {
        if (!fullPath) return null;
        try {
          const url = new URL(fullPath);
          const baseOrigin = new URL(appUrl.BASE_URL).origin;
          return `${baseOrigin}${url.pathname}`;
        } catch (error) {
          return fullPath;
        }
      };

      // ── Action column ─────────────────────────────────────────────────────────
     const actionBodyTemplate = (rowData) => {
  if (rowData.parkingId === null || rowData.parkingId === undefined) {
    return (
      <Button
        label="Resolve"
        icon="pi pi-check-circle"
        className="p-button-sm p-button-warning"
        onClick={() => openResolveDialog(rowData)}
      />
    );
  }
  return <span>—</span>;
};
      // ──────────────────────────────────────────────────────────────────────────

      return (
        <>
          {/* ── Plate Image Dialog ───────────────────────────────────────────── */}
          <Dialog
            visible={imageDialog}
            onHide={() => setImageDialog(false)}
            header="Plate Image"
            modal
            style={{ width: "50vw" }}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="full-plate"
                style={{ width: "100%", borderRadius: "10px" }}
              />
            )}
          </Dialog>

          {/* ── Resolve Dialog ───────────────────────────────────────────────── */}
          <Dialog
            visible={resolveDialog}
            onHide={() => !resolveLoading && setResolveDialog(false)}
            header={null}
            modal
            style={{ width: "560px" }}
          >
            <h5 className="mb-4 ml-1" style={{ fontWeight: "bold" }}>
              Resolve Manual Barrier Log
            </h5>
            <div className="brdr__top">
              <div className="card">
                <div className="p-fluid formgrid grid">

                  {/* Plate No — read only */}
                  <div className="field col-12 md:col-6">
                    <label style={{ fontWeight: "bold" }}>Plate No</label>
                    <InputText
                      value={resolveRow?.cameraSetPlateNo || ""}
                      className="TextArea__Round"
                      readOnly
                      disabled
                    />
                  </div>

                  {/* Site — read only */}
                  <div className="field col-12 md:col-6">
                    <label style={{ fontWeight: "bold" }}>Site</label>
                    <InputText
                      value={resolveRow?.siteName || ""}
                      className="TextArea__Round"
                      readOnly
                      disabled
                    />
                  </div>

                  {/* Booth — read only */}
                  <div className="field col-12 md:col-6">
                    <label style={{ fontWeight: "bold" }}>Booth</label>
                    <InputText
                      value={resolveRow?.booth || ""}
                      className="TextArea__Round"
                      readOnly
                      disabled
                    />
                  </div>

                

                  {/* Ticket Number — required */}
                  <div className="field col-12 md:col-6">
                    <label style={{ fontWeight: "bold" }}>
                      Ticket Number
                    </label>
                    <span className="Label__Required" style={{ color: "red" }}>
                      {" "}*
                    </span>
                    <InputText
                      value={ticketNo}
                      onChange={(e) => setTicketNo(e.target.value)}
                      placeholder="Enter ticket number"
                      className="TextArea__Round"
                    />
                  </div>

                  {/* Description — optional */}
                  <div className="field col-12 md:col-12">
                    <label style={{ fontWeight: "bold" }}>
                      Description{" "}
                      <span style={{ fontWeight: 400, color: "#9ca3af", fontSize: "12px" }}>
                        (optional)
                      </span>
                    </label>
                    <InputTextarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Enter description"
                      rows={2}
                      autoResize
                      className="TextArea__Round"
                      style={{ resize: "none" }}
                    />
                  </div>

                  {/* Ticket Image — optional */}
                  <div className="field col-12">
                    <label style={{ fontWeight: "bold" }}>
                      Ticket Image{" "}
                      <span style={{ fontWeight: 400, color: "#9ca3af", fontSize: "12px" }}>
                        (optional)
                      </span>
                    </label>
                    <div
                      style={{
                        border: "2px dashed #ced4da",
                        borderRadius: "8px",
                        padding: "16px",
                        cursor: "pointer",
                        textAlign: "center",
                        backgroundColor: "#f8f9fa",
                        transition: "border-color 0.2s",
                      }}
                      onClick={() =>
                        document.getElementById("ticketImageInput").click()
                      }
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.borderColor = "#6366f1")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.borderColor = "#ced4da")
                      }
                    >
                      {ticketImagePreview ? (
                        <div className="flex flex-column align-items-center gap-2">
                          <img
                            src={ticketImagePreview}
                            alt="ticket preview"
                            style={{
                              width: 90,
                              height: 90,
                              objectFit: "cover",
                              borderRadius: "8px",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                            }}
                          />
                          <span style={{ fontSize: "12px", color: "#6b7280" }}>
                            Click to change image
                          </span>
                        </div>
                      ) : (
                        <div className="flex flex-column align-items-center gap-2">
                          <i
                            className="pi pi-image"
                            style={{ fontSize: "2.2rem", color: "#9ca3af" }}
                          />
                          <span style={{ fontSize: "13px", color: "#6b7280" }}>
                            Click to upload ticket image
                          </span>
                          <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                            PNG, JPG supported
                          </span>
                        </div>
                      )}
                    </div>
                    <input
                      id="ticketImageInput"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          const base64 = reader.result.split(",")[1];
                          setTicketImageB64(base64);
                          setTicketImagePreview(reader.result);
                        };
                        reader.readAsDataURL(file);
                      }}
                    />
                  </div>

                  {/* Action Buttons */}
                  <div className="col-12 mt-3 flex justify-content-end">
                    <Button
                      label="Cancel"
                      className="Cancel__button mr-3"
                      type="button"
                      onClick={() => setResolveDialog(false)}
                      disabled={resolveLoading}
                    />
                    <Button
                      label="Resolve"
                      icon="pi pi-check"
                      type="button"
                      className="Save__Button"
                      onClick={handleResolve}
                      loading={resolveLoading}
                    />
                  </div>

                </div>
              </div>
            </div>
          </Dialog>

          {/* ── Main content ─────────────────────────────────────────────────── */}
          <div className="p-fluid grid">
            <div className="col-12 flex justify-content-end align-items-center">
              <div className="field">
                <InputText
                  className="mbl_view mr-2"
                  style={{ borderRadius: "100px" }}
                  value={globalFilterValue}
                  onChange={onGlobalFilterChange}
                  placeholder="Search"
                />
              </div>

              <div className="field ml-3">
                <Button
                  label={`Filters (${appliedFilters})`}
                  icon="pi pi-filter"
                  onClick={() => setShowFilters((prevState) => !prevState)}
                  style={{
                    backgroundColor: showFilters ? "" : "transparent",
                    color: showFilters ? "white" : "black",
                    boxShadow: "none",
                    borderRadius: "100px",
                  }}
                />
              </div>

              <div className="field ml-3 rounded-lg">
                <Button
                  label={exportLoading ? "Exporting..." : "Export to Excel"}
                  type="button"
                  style={{ borderRadius: "100px" }}
                  icon="pi pi-file-excel"
                  severity="success"
                  disabled={loading || exportLoading}
                  onClick={exportExcel}
                />
              </div>
            </div>

            {showFilters && (
              <div className="flex flex-row flex-wrap gap-3 mt-3 w-full mb-3">
                <div className="flex-1 min-w-[200px]">
                  <Dropdown
                    id="site"
                    name="site"
                    value={formik.values.site}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setSiteId(e.target.value);
                    }}
                    filter
                    filterBy="site"
                    filterMatchMode="contains"
                    className={classNames(
                      { "p-invalid": isFormFieldValid("site") },
                      "w-full TextArea__Round border-round-3xl"
                    )}
                    options={siteList}
                    optionLabel="site"
                    optionValue="_id"
                    placeholder="Select Site"
                    disabled={isSiteFixed || !!queryParams.get("site")}
                    showClear
                  />
                  {getFormErrorMessage("site")}
                </div>

                <div className="flex-1 min-w-[200px]">
                  <Dropdown
                    id="boothId"
                    name="boothId"
                    value={formik.values.boothId}
                    onChange={(e) => {
                      formik.handleChange(e);
                      setBooothId(e.target.value);
                    }}
                    filter
                    filterBy="boothId"
                    filterMatchMode="contains"
                    className={classNames(
                      { "p-invalid": isFormFieldValid("boothId") },
                      "w-full TextArea__Round border-round-3xl"
                    )}
                    options={boothList}
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="Select Booth"
                    disabled={isSiteFixed || !!queryParams.get("site")}
                    showClear
                  />
                  {getFormErrorMessage("boothId")}
                </div>

                <div className="flex-1 min-w-[200px]">
                  <Dropdown
                    id="vehicleType"
                    name="vehicleType"
                    value={selectedVehicleType}
                    onChange={(e) => setSelectedVehicleType(e.value)}
                    filter
                    filterBy="name"
                    filterMatchMode="contains"
                    className="w-full TextArea__Round border-round-3xl"
                    options={vehicleTypeList}
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="Select Vehicle Type"
                    showClear
                  />
                </div>

                <div className="flex-1 min-w-[160px]">
                  <InputText
                    id="fromDate"
                    name="fromDate"
                    value={fromDate}
                    onChange={handleDateChange}
                    type="date"
                    placeholder="From Date"
                    className="w-full border-round-3xl"
                    readOnly={loading}
                  />
                </div>

                <div className="flex-1 min-w-[160px]">
                  <InputText
                    id="toDate"
                    name="toDate"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    type="date"
                    placeholder="To Date"
                    className="w-full border-round-3xl"
                    readOnly={loading}
                  />
                </div>

                <div className="flex-1 min-w-[160px] flex align-items-center">
                  <Checkbox
                    inputId="isCheckInMissing"
                    checked={isCheckInMissing}
                    onChange={(e) => setIsCheckInMissing(e.checked)}
                  />
                  <label htmlFor="isCheckInMissing" className="ml-2">
                    Check-In Missing
                  </label>
                </div>

                <div
                  className="flex justify-content-end align-items-center"
                  style={{ flexGrow: 1 }}
                >
                  <Button
                    label="Search"
                    icon="pi pi-search"
                    className="p-button-rounded p-button-info ml-auto"
                    onClick={() => {
                      setInitialized(true);
                      getDashData();
                    }}
                    disabled={loading}
                  />
                </div>
              </div>
            )}
          </div>

          {dashStat === undefined ? (
            <h1>Loading...</h1>
          ) : (
            <div className="grid">
              <div className="col-12 md:col-12">
                <div className="card">
                  <DataTable
                    value={dashList}
                    paginator
                    rows={currentPageSize}
                    totalRecords={totalRecords}
                    first={(currentPage - 1) * currentPageSize}
                    onPage={(e) => {
                      const newPage = e.page + 1;
                      const newPageSize = e.rows;
                      setCurrentPage(newPage);
                      setCurrentPageSize(newPageSize);
                      getDashData(newPage, newPageSize, globalFilterValue);
                    }}
                    loading={loading}
                    lazy
                    scrollable
                    emptyMessage="No records found"
                  >
                    <Column field="siteName" header="Site Name" />
                    <Column field="booth" header="Booth" />
                    <Column field="cameraSetPlateNo" header="Plate No" />
                    <Column field="isCheckInMissing" header="Check-In Missing" />
                    <Column
                      field="createdAt"
                      header="Created At"
                      body={(rowData) => {
                        if (!rowData.createdAt) return "-";
                        return moment
                          .utc(rowData.createdAt)
                          .format("hh:mm:ss A YYYY-MM-DD");
                      }}
                    />
                    <Column field="createdBy" header="Created By" />
                    <Column
  field="mappedAt"
  header="Mapped At"
  body={(rowData) => {
    if (!rowData.mappedAt) return "-";
    return moment.utc(rowData.mappedAt).format("hh:mm:ss A YYYY-MM-DD");
  }}
/>
<Column
  field="mappedByUser"
  header="Mapped By"
  body={(rowData) => rowData.mappedByUser || "-"}
/>
<Column
  field="description"
  header="Description"
  body={(rowData) => rowData.description || "-"}
/>
<Column
  field="ticketImagePath"
  header="Ticket Image Path"
  body={(rowData) => rowData.ticketImagePath || "-"}
/>
                    <Column
                      field="plateImagePath"
                      header="Plate Image"
                      body={(rowData) => {
                        const imageUrl = getImageUrl(rowData.plateImagePath);
                        return imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="plate"
                            onClick={() => openImage(imageUrl)}
                            style={{
                              width: 35,
                              height: 35,
                              objectFit: "cover",
                              borderRadius: "50%",
                              cursor: "pointer",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.style.display = "none";
                              e.target.parentElement.innerText = "N/A";
                            }}
                          />
                        ) : (
                          "-"
                        );
                      }}
                    />

                    {/* ── Resolve action column ── */}
                
        <Column
            header="Action"
            body={actionBodyTemplate}
            style={{ minWidth: "130px" }}
        />
    
                  </DataTable>
                </div>
              </div>
            </div>
          )}
        </>
      );
    };

    export default BarrierLogReport;
